import React, { useEffect, useState } from 'react';
import { XMarkIcon, BeakerIcon } from '@heroicons/react/24/outline';
import { fetchOnboardingManifest } from '../../services/onboardingApi';

export default function DemoEnvironmentBanner({ organizationId }) {
  const [manifest, setManifest] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!organizationId) return;
    const key = `demo_banner_dismissed_${organizationId}`;
    if (sessionStorage.getItem(key) === '1') {
      setDismissed(true);
      return;
    }
    fetchOnboardingManifest(organizationId)
      .then((data) => {
        if (data?.scenario_id) setManifest(data);
      })
      .catch(() => {});
  }, [organizationId]);

  if (dismissed || !manifest?.scenario_id) return null;

  const dismiss = () => {
    sessionStorage.setItem(`demo_banner_dismissed_${organizationId}`, '1');
    setDismissed(true);
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-between gap-3 text-sm text-amber-900">
      <div className="flex items-center gap-2 min-w-0">
        <BeakerIcon className="w-5 h-5 shrink-0 text-amber-700" />
        <span className="truncate">
          Guided demo environment — synthetic data only. Scenario: <strong>{manifest.scenario_id}</strong>
        </span>
      </div>
      <button type="button" onClick={dismiss} className="text-amber-700 hover:text-amber-900 shrink-0" aria-label="Dismiss">
        <XMarkIcon className="w-5 h-5" />
      </button>
    </div>
  );
}
